import componentBoxLogo from "../assets/img/componentbox_logo.svg"

const projectLogos: { [id: string]: any } = {
    'R_kgDOG7CkEQ': componentBoxLogo
}

export default projectLogos
